/**
 * @deprecated
 * This verification record type is deprecated.
 * DO NOT use this verification record type in new code.
 */
import { z } from 'zod';
import { UsersPasswordEncryptionMethod } from '../../db-entries/custom-types.js';
import { interactionIdentifierGuard } from '../interactions.js';
import { VerificationType } from './verification-type.js';
export const newPasswordIdentityVerificationRecordDataGuard = z.object({
    id: z.string(),
    type: z.literal(VerificationType.NewPasswordIdentity),
    identifier: interactionIdentifierGuard,
    passwordEncrypted: z.string().optional(),
    passwordEncryptionMethod: z.literal(UsersPasswordEncryptionMethod.Argon2i).optional(),
});
